import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  mapActions
} from 'vuex'
import 'animate.css'
//  reset CSS
import "normalize.css/normalize.css";
import VConsole from "vconsole"
import VueClipboard from 'vue-clipboard2'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css"
import '@/styles/index.scss' // global css
import '@/assets/js/validateConfig'
import {
  compressFile,
  compressFileOld
} from '@/utils'
import {
  getPersistentStorage,
  monitorPersistentStorage
} from '@/utils'
import privatelyowned from 'privatelyowned'
Vue.component('CommonOffice', privatelyowned)
Vue.prototype.$monitorPersistentStorage = monitorPersistentStorage // 添加持久化数据
Vue.prototype.$getPersistentStorage = getPersistentStorage // 获取持久化数据

Vue.prototype.$compressFile = compressFile
Vue.prototype.$compressFileOld = compressFileOld

if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('test.joineast.com') > -1 || window.location.href.indexOf('itest.joineast.com') > -1) {
  new VConsole()
}

import SlideVerify from 'vue-monoplasty-slide-verify'; //vuew支持滑动验证码
import '@/permission' // permission control

// 全局变量
import global_ from '@/utils/param' // fl

Vue.prototype.$global = global_ // fl
Vue.use(ElementUI);
Vue.use(SlideVerify);
Vue.use(VueClipboard)
// Vue.use(lrz);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.getSystemType().then(res => {
      this.login()
      this.outLimit()
    })
  },
  methods: {
    ...mapActions([
      'login',
      'outLimit',
      'getSystemType'
    ]),
  },
}).$mount("#app");